<template>
    <div class="teamwork">
        <div class="container-xl">
            <div class="header-bottom">
                <div class="line-style">
                    <span class="dot"></span>
                    <span class="lines"></span>
                </div>
                <div class="font-size">
                    <div class="text">企业合作案例</div>
                    <div class="letter">Business Cooperation Cases</div>
                </div>
                <div class="line-style">
                    <span class="lines"></span>
                    <span class="dot"></span>
                </div>
            </div>
        </div>
        <div class="container-xl">
            <div class="team-box">
                <div class="team-contral">
                    <div class="item" :class="{'active':activeIndex===0}" @click="handleToggleIndex(0)">01</div>
                    <div class="item" :class="{'active':activeIndex===1}" @click="handleToggleIndex(1)">02</div>
                    <div class="item" :class="{'active':activeIndex===2}" @click="handleToggleIndex(2)">03</div>
                </div>
                <div class="team-view ">
                    <div class="team-img">
                        <img :src="require(`@/assets/homepages/work${activeIndex+1}.png`)" style="width: 100%;height: 100%;" alt="">
                    </div>
                </div>
                <div class="team-content">
                    <div style="margin-bottom: 23px;font-weight: bold;">{{activeIndex===0?'定制循环取货路线':activeIndex===1?'园区智能物流':'生鲜空地联运'}}</div>
                    <div>{{activeIndex===0?'为某大型消费电子科技公司定制mlik-run模式，并打通双方系统接口。降低了运输成本，物料配送准确率和准时率大幅提升。':activeIndex===1?'以无人转运降本、灵活调配增效、数字工具透明化为核心优势，为某合作企业园区革新物流模式。':'小蜂蜂通过系统与空运航班信息联动，提前调配优质车源和司机。使得生鲜在第一时间离开空运段后无缝衔接地面运输。地面段运输相比传统模式减少6小时等候时间。'}}</div>
                </div>
            </div>
            <div class="center-label">部分合作客户展示</div>
            <div class="center-subtext">Featured Clients</div>
            <div class="container" style="padding: 0;">
                <div class="work-team">
                    <img src="@/assets/homepages/work-team.png" style="width: 100%;height: auto;" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeIndex:0,
        }
    },
    created(){
        this.init();
    },
    methods:{
        init(){
            setInterval(()=>{
                this.activeIndex ++;
                if(this.activeIndex > 2)this.activeIndex = 0;
                this.handleToggleIndex(this.activeIndex);
            },10000)
        },
        handleToggleIndex(index){
            this.activeIndex=index;
            var ele = document.querySelector('.team-img')
            ele.classList.add('animate__animated','animate__slideInLeft')
            ele.addEventListener('animationend', () => {
                ele.classList.remove('animate__animated','animate__slideInLeft')
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.teamwork {
    padding-bottom: 80px;
    background-color: #ffffff;
    .header-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.3rem 0;
    .line-style {
        flex: 1;
      height: 10px;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        background: #181818;
        opacity: 1;
      }
      .dot {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
      .lines {
        flex: 1;
        height: 1px;
      }
    }
    .font-size {
      margin: 0 20px;
      .text,
      .letter {
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #181818;
      }
      .text {
        font-size: 40px;
      }
      .letter {
        font-size: 20px;
        font-family: PingFangSC;
      }
    }
  }
  .team-box {
    display: flex;
    justify-content: center;
    .team-contral {
        width: 100px;
        background-color: #DBD1C1;
        margin-right: 100px;
        padding: 62px 0;
        display: flex;
        flex-direction: column;
        .item {
            flex: 1;
            font-size: 24px;
            line-height: 60px;
            color: #ffffff;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .active {
            color: #181818;
            font-weight: bold;
            position: relative;
            &::after {
                content: '';
                display: inline-block;
                // width: 100px;
                width: .5rem;
                height: 0.01rem;
                // height: 1px;
                background-color: #181818;
                position: absolute;
                top: 50%;
                left: 80%;
            }
        }
    }
    .team-view {
        width: 684px;
        height: 424px;
        border: 8px solid #E6DED1;
        overflow: hidden;
    }
    .team-img {
        width: 100%;
        height: 100%;
        animation-timing-function:linear;
        animation-duration: 600ms;
    }
    .team-content {
        font-size: 20px;
        text-align: left;
        flex: 1;
        margin-left: 35px;
        &>div {
            font-family: 'PingFangSC';
        }
    }
  }
  .center-label {
    font-size: 28px;
    margin-top: 50px;
    margin-bottom: 4px;
  }
  .center-subtext {
    font-size: 20px;
  }
  .work-team {
    // width: 990px;
    // height: 470px;
    background-color: #f5f5f5;
    margin-top: 20px;
  }
}
</style>